import { HttpMethod, HttpOption } from '@/utils/http-client'
import { SubjectPageRequestModel } from '@/api/model/subject'

export class SubjectAPIConstant {
    queryFundPage = (data: SubjectPageRequestModel): HttpOption => ({
        url: '/fundcloud/fundMemberDetail/selectFundMemberDetailPage',
        method: HttpMethod.POST,
        data
    })
}
